import { BrowserRouter } from "react-router-dom";
import AllRoutes from "./AllRoutes";
import React from "react";
import "./app.css";
import { AuthProvider } from "./contexts/Auth/AuthProvider";
import { NotificationProvider } from "./contexts/NotificationContext";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { GlobalRateLimitBlock } from "./components/GlobalRateLimitBlock";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <NotificationProvider>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <AllRoutes />
            <GlobalRateLimitBlock />
          </BrowserRouter>
        </NotificationProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
